/**
 * AuthRouter — gates the app behind the auth flow state machine.
 *
 *   unauthenticated         → <LoginPage />
 *   password_reset_required → <PasswordResetPage />
 *   mfa_enroll_required     → <MfaEnrollPage />
 *   mfa_required            → <MfaVerifyPage />
 *   authenticated           → children (the portal shell)
 */
import React from 'react';
import { useAuth, FLOW } from './AuthProvider';
import LoginPage from './pages/LoginPage';
import PasswordResetPage from './pages/PasswordResetPage';
import MfaEnrollPage from './pages/MfaEnrollPage';
import MfaVerifyPage from './pages/MfaVerifyPage';

function FullScreenSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-base dark:bg-surface-dark-base">
      <div className="text-sm text-surface-muted dark:text-surface-dark-muted">Loading…</div>
    </div>
  );
}

export default function AuthRouter({ children }) {
  const { loading, flow } = useAuth();

  if (loading) return <FullScreenSpinner />;

  switch (flow) {
    case FLOW.AUTHENTICATED:           return children;
    case FLOW.PASSWORD_RESET_REQUIRED: return <PasswordResetPage />;
    case FLOW.MFA_ENROLL_REQUIRED:     return <MfaEnrollPage />;
    case FLOW.MFA_REQUIRED:            return <MfaVerifyPage />;
    case FLOW.UNAUTHENTICATED:
    default:                           return <LoginPage />;
  }
}
